import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
export const uncompletedPendingDropsAlertEndpoint = {
    [dropEndpointIds.UNCOMPLETED_PENDING_DROPS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
